import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { SectionContainer, SectionHeader, SectionContent } from './FilterSection.styled';

const FilterSection = ({ title, children, defaultOpen = true }) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <SectionContainer>
      <SectionHeader isOpen={isOpen} onClick={() => setIsOpen(!isOpen)}>
        <span>{title}</span>
        <i className="mdi mdi-chevron-down" />
      </SectionHeader>
      <SectionContent isOpen={isOpen}>{children}</SectionContent>
    </SectionContainer>
  );
};

FilterSection.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
  defaultOpen: PropTypes.bool,
};

export default FilterSection;


